// extracted by mini-css-extract-plugin
module.exports = {"popup":"Popup_popup__2WdWD","visible":"Popup_visible__3oTJc","popupWrapper":"Popup_popupWrapper__1WjDK"};